import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';

/**
 * Standard debounced-autocomplete pipeline: debounce, drop repeats, then
 * switch to the latest search. `searchFn` owns any min-length gating and
 * error handling for its own call — this just wires the operator chain.
 */
export function debouncedSearch$<T>(
  source$: Observable<string>,
  searchFn: (term: string) => Observable<T[]>,
): Observable<T[]> {
  return source$.pipe(debounceTime(300), distinctUntilChanged(), switchMap(searchFn));
}
